import React, {Component} from "react";
import {Input} from "antd";
import {inject} from "mobx-react";
import './CarPlateField.css';
import {PencilIcon} from "../../../../../common/icons";
import SmallButton from "../../../DriversManagerDashboard/SelectableDrivers/DriversTable/SmallButton";

@inject('translationsStore', 'carsStore')
class CarPlateField extends Component {
  constructor(props) {
    super(props);

    const showInput = false;
    const nickname = props.record.nickname ? props.record.nickname : props.record.plate;

    this.state = {
      showInput: showInput, nickname: nickname,
    };

    this.inputRef = React.createRef();
  }

  handleClick = () => {
    this.setState(prev => ({
      ...prev,
      showInput: true
    }), () => {
      // Focus the input after state update is complete
      if (this.inputRef.current) {
        this.inputRef.current.focus();
      }
    });
  }

  handleNicknameChange = (e) => {
    const newNickname = e.target.value
    this.setState(prev => ({...prev, nickname: newNickname}));
  }

  handleNicknameBlur = () => {
    if (!this.state.nickname) {
      this.setState({
        showInput: false,
        nickname: this.props.record.plate,
      });
      this.props.carsStore.updateCar(this.props.record.plate, {nickname: null})
      return
    }
    if (this.state.nickname === this.props.record.plate) {
      this.setState({showInput: false});
      this.props.carsStore.updateCar(this.props.record.plate, {nickname: null})
      return
    }

    this.setState(prev => ({ ...prev, showInput: false}));
    this.props.carsStore.updateCar(this.props.record.plate, {nickname: this.state.nickname})
  }

  render() {
    let fieldToShow;

    if (this.state.showInput) {
      fieldToShow = <Input
        maxLength={15}
        ref={this.inputRef}
        placeholder={this.props.translationsStore.translate('groupsManager.vehicleTable.fieldLabels.plate.note')}
        onChange={this.handleNicknameChange}
        onBlur={this.handleNicknameBlur}
        value={this.state.nickname}
        size="small"
        style={{width: '100px'}}
      />
    } else {
      if (!this.props.record.plate) {
        fieldToShow = <span>-</span>
      } else {
        let fieldText = ''
        if (this.state.nickname) {
          fieldText = this.state.nickname
        } else {
          fieldText = this.props.record.nickname ? this.props.record.nickname : this.props.record.plate
        }

        fieldToShow = <span>{fieldText}</span>
      }
    }

    return (<div className="FieldContainer">
      {!this.state.showInput && <SmallButton onClick={this.handleClick}>
        <PencilIcon/>
      </SmallButton>}
      {fieldToShow}
    </div>);
  }
}

export default CarPlateField;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/ClientsWithGroups/ClientsTable/CarPlateField.js